import React, { useState, useEffect, useMemo } from 'react';
import {
    fetchHealthTechBanner, fetchTechnologyServicesAboutUsList, fetchAdvancedMedicalEquipmentDetailsList,
    fetchHospitalServicesDetailsList, fetchHospitalHomeCareServicesList, fetchHospitalOtherServicesList
} from "../Adapter/PageAdapter";
import { baseImage_path } from "../variables/Variables";
import useSeo from "../hooks/useSeo";
import SeoHelmet from "../components/SeoHelmet";
import logoSvg from '../assets/images/slraheja-logo-svg.svg';
import banerImg from "../assets/images/careerdetailban.jpg";
import htsleft from '../assets/images/htsleftone.jpg';
import htslefttwo from '../assets/images/htslefttwo.jpg';

import htsnurse from '../assets/images/htsnurse.svg';
import htsnursing from '../assets/images/htsnursing.svg';
import htsxray from '../assets/images/htsxray.svg';
import htsmediequp from '../assets/images/htsmediequp.svg';
import phlebotomy from '../assets/images/phlebotomy.svg';
import bandage from '../assets/images/bandage.svg';
import doctor from '../assets/images/doctor.svg';
import sleep from '../assets/images/sleep.svg';
import ambulance from '../assets/images/ambulance.svg';
import destination from '../assets/images/destination.svg';

const HospitalTechnologService = () => {
    var expanded = false;
    const servicesList = [
        { img: htsnurse, title: 'Private Caretakers Nursing Attendants', desc: 'One-on-one personalized care.' },
        { img: htsnursing, title: 'Specialized Home Nursing', desc: 'Post-hospitalization care, injections, and chronic disease management.' },
        { img: htsxray, title: 'X-Ray @ Home', desc: 'Get diagnostic imaging without leaving home.' },
        { img: htsmediequp, title: 'Medical Equipment Rental', desc: 'Oxygen concentrators, ventilators, and more.' },
        { img: phlebotomy, title: 'Phlebotomy (Home Sample Collection)', desc: 'Hassle-free blood tests at home.' },
        { img: bandage, title: 'Wound Dressing', desc: 'Professional post-surgical care and dressing changes.' },
        { img: doctor, title: 'Physiotherapy @ Home', desc: 'Personalized rehab sessions for faster recovery.' },
        { img: sleep, title: 'Sleep Study @ Home', desc: 'Diagnose sleep disorders conveniently.' },
        { img: ambulance, title: '24x7 Ambulance Services', desc: 'Emergency medical transport, just a call away.' },
        { img: destination, title: 'Pharmacy Home Delivery', desc: 'Medicines delivered within 5 km (Min. order ₹1,000 | 8 AM - 8 PM).' },
    ];

    const [serv] = useState(servicesList);
    const [numberOfitemsShown, setNumberOfItemsToShown] = useState(4);
    const [buttonText, setButtonText] = useState('View All');
    const [bannerData, setBannerData] = useState(null);
    const [aboutUsContent, setAboutUsContent] = useState([]);
    const [medicalEquipment, setMedicalEquipment] = useState([]);
    const [hospitalServices, setHospitalServices] = useState([]);
    const [homeCareServices, setHomeCareServices] = useState([]);
    const [otherServices, setOtherServices] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const bannerResponse = await fetchHealthTechBanner();
                setBannerData(bannerResponse?.data || null);

                const aboutUsResponse = await fetchTechnologyServicesAboutUsList();
                setAboutUsContent(aboutUsResponse?.data || []);

                const medicalEquipmentResponse = await fetchAdvancedMedicalEquipmentDetailsList();
                setMedicalEquipment(medicalEquipmentResponse?.data || []);

                const hospitalServicesResponse = await fetchHospitalServicesDetailsList();
                setHospitalServices(hospitalServicesResponse?.data || []);

                const homeCareServicesResponse = await fetchHospitalHomeCareServicesList();
                setHomeCareServices(homeCareServicesResponse?.data || []);

                const otherServicesResponse = await fetchHospitalOtherServicesList();
                setOtherServices(otherServicesResponse?.data || []);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const showMore = () => {
        if (numberOfitemsShown < serv.length) {
            setNumberOfItemsToShown(serv.length);
            setButtonText('View Less');
        } else {
            setNumberOfItemsToShown(4);
            setButtonText('View All');
        }
    };

    const img = (p) => `${baseImage_path}/${p?.replace(/^\.?\//, "")}`;

    const itemsToShow = useMemo(() => {
        return serv
            .slice(0, numberOfitemsShown)
            .map((servItem, index) => <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 mb-4" key={index}>
                <div className="card-end text-center cardend-border tormvmrgnfromhead rmjustspxbtw">
                    <div className="cardi-img">
                        <img src={servItem.img} alt="Private Caretakers" />
                    </div>
                    <div className="hts-service-title">
                        <h3>{servItem.title}</h3>
                    </div>
                    <div className="hts-service-desc">

                        <p>{servItem.desc}</p>
                    </div>

                </div>
            </div>);
    }, [serv, numberOfitemsShown]);

    const cards = useMemo(() => homeCareServices
        .slice(0, numberOfitemsShown)
        .map((svc) => (
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 mb-4" key={svc.id}>
                <div className="card-end text-center cardend-border tormvmrgnfromhead rmjustspxbtw">
                    <div className="cardi-img">
                        <img src={img(svc.icon_path)} alt={svc.heading} />
                    </div>
                    <div className="hts-service-title"><h3>{svc.heading}</h3></div>
                    <div className="hts-service-desc"><p>{svc.content}</p></div>
                </div>
            </div>
        )), [homeCareServices, numberOfitemsShown]);

    return (
        <>
            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        <img src={banerImg} alt="Hospital Technology & Services" />
                        <div className="ban-con">
                            <h1>Hospital Technology & Services</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section about-host">
                <div className="cust-container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="host-img careerjoinsec">
                                <img src={htsleft} alt="Worl class healthcare" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="finnest host-det mobtopmarg careerjoininner">
                                <h5>World-Class Healthcare at S.L. Raheja Hospital - A Fortis Associate</h5>
                                <h4>Hospital <span>Technology & Services</span></h4>

                                <p>At S.L. Raheja Hospital - A Fortis Associate, we are committed to delivering world-class healthcare through cutting-edge technology and state-of-the-art infrastructure. Our advanced medical equipment and diagnostic tools enable precise, efficient, and minimally invasive treatments, ensuring the best outcomes for our patients.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section className="international-pat-service-sec mrgntop70 margnbot90">
                <div className="cust-container">

                    <div className="international-pat-service-inner">
                        <div className="int-pat-tabs">
                            <ul className="nav nav-pills justify-content-center academic-ul intpat-ul" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active doccls" id="pre-arrivassist" data-toggle="pill" data-target="#prearrivalpill" type="button" role="tab" aria-controls="pills-doc" aria-selected="true">
                                        <span>Technology</span>
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link nursecls" id="arrivalandstay" data-toggle="pill" data-target="#arstaypill" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">
                                        <span>Services</span>
                                    </button>
                                </li>
                            </ul>

                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="prearrivalpill" role="tabpanel" aria-labelledby="pre-arrivassist">
                                    <div className="innertab-head">
                                        <div className="finnest host-det mobtopmarg">
                                            <h2 className="section-title text-center"><span>Advanced Medical Equipment</span></h2>
                                        </div>
                                    </div>
                                    <div className="faqsec-inner">
                                        <div className="accordion w-100" id="technology-faqs">
                                            {medicalEquipment.map((cat, cIdx) => (
                                                <div className="card" key={cat.category_id}>
                                                    <div className="card-header" id={`techHead${cIdx}`}>
                                                        <button
                                                            className={`collpase ${cIdx ? 'collapsed' : ''}`}
                                                            data-toggle="collapse"
                                                            data-target={`#techCol${cIdx}`}
                                                            aria-expanded={!cIdx}
                                                        >
                                                            {cat.category_name.replace(/&amp;/g, '&')}
                                                        </button>
                                                    </div>

                                                    <div
                                                        id={`techCol${cIdx}`}
                                                        className={`collapse ${!cIdx ? 'show' : ''}`}
                                                        data-parent="#technology-faqs"
                                                    >
                                                        <div className="card-body">
                                                            <div className="row">
                                                                {/* left nav */}
                                                                <div className="col-xl-4 col-lg-4 mb-4">
                                                                    <ul className="nav nav-pills justify-content-center innertabul" id="inner-tab">
                                                                        {cat.details.map((eq, eIdx) => (
                                                                            <li className="nav-item" key={eq.equipment_id}>
                                                                                <button
                                                                                    className={`nav-link doccls  ${!eIdx ? 'active' : ''}`}
                                                                                    data-toggle="pill"
                                                                                    data-target={`#techTab${cat.category_id}_${eq.equipment_id}`}
                                                                                >
                                                                                    {eq.equipment_heading}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </div>

                                                                {/* right content */}
                                                                <div className="col-xl-8 col-lg-8 mb-4">
                                                                    <div className="tab-content">
                                                                        {cat.details.map((eq, eIdx) => (
                                                                            <div
                                                                                key={eq.equipment_id}
                                                                                id={`techTab${cat.category_id}_${eq.equipment_id}`}
                                                                                className={`tab-pane fade ${!eIdx ? 'show active' : ''}`}
                                                                            >
                                                                                <div className="hts-innertabs">
                                                                                    <div className="hts-iner-tab-item hts-iner-service-tab">
                                                                                        {/* <div className="htsiner-img">
                                                                                            <img src={img(eq.equipment_img_path)} alt={eq.equipment_heading} />
                                                                                        </div> */}
                                                                                        <div className="htsiner-img">
                                                                                            {eq.equipment_img_path ? (
                                                                                                <img src={img(eq.equipment_img_path)} alt={eq.equipment_heading} />
                                                                                            ) : (
                                                                                                <div
                                                                                                    className="d-flex align-items-center justify-content-center"
                                                                                                    style={{
                                                                                                        width: '100%',
                                                                                                        height: '200px',
                                                                                                        backgroundColor: '#f1f1f1',
                                                                                                        borderRadius: '10px',
                                                                                                    }}
                                                                                                >
                                                                                                    <img src={logoSvg} alt="SL Raheja Hospital" style={{ maxHeight: '80px' }} />
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                        <div className="hts-innerdesc">
                                                                                            <p>{eq.equipment_content}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="arstaypill" role="tabpanel" aria-labelledby="arrivalandstay">
                                    <div className="innertab-head">
                                        <div className="finnest host-det text-center mobtopmarg">
                                            <h2 className="section-title text-center"><span>Hospital Services</span></h2>
                                            <p className="text-center">A strong foundation is key to delivering exceptional patient care. Our hospital has 170 beds, including specialized units designed to treat critically ill patients. Here’s a glimpse of our special units.</p>
                                        </div>
                                    </div>
                                    <div className="faqsec-inner">
                                        <div className="accordion w-100" id="hospi-servi-faqs">
                                            {hospitalServices.map((srv, sIdx) => (
                                                <div className="card" key={srv.id}>
                                                    <div className="card-header" id={`servHead${sIdx}`}>
                                                        <button
                                                            className={`collapse ${sIdx ? 'collapsed' : ''}`}
                                                            data-toggle="collapse"
                                                            data-target={`#servCol${sIdx}`}
                                                            aria-expanded={!sIdx}
                                                        >
                                                            {srv.heading}
                                                        </button>
                                                    </div>

                                                    <div
                                                        id={`servCol${sIdx}`}
                                                        className={`collapse ${!sIdx ? 'show' : ''}`}
                                                        data-parent="#hospi-servi-faqs"
                                                    >
                                                        <div className="card-body">
                                                            <div className="hts-innertabs">
                                                                <div className="hts-iner-tab-item hts-iner-service-tab">
                                                                    <div className="htsiner-img">
                                                                        {srv.img_path ? (
                                                                            <img src={img(srv.img_path)} alt={srv.heading} />
                                                                        ) : (
                                                                            <div
                                                                                className="d-flex align-items-center justify-content-center"
                                                                                style={{
                                                                                    width: '100%',
                                                                                    height: '200px',
                                                                                    backgroundColor: '#f1f1f1',
                                                                                    borderRadius: '10px',
                                                                                }}
                                                                            >
                                                                                <img src={logoSvg} alt="SL Raheja Hospital" style={{ maxHeight: '80px' }} />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="hts-innerdesc">
                                                                        <p>{srv.content}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="fivepointsec card-pblk mrgntop70 margnbot90">
                <div className="cust-container">
                    <div className="innertab-head">
                        <div className="finnest host-det text-center mobtopmarg">
                            <h2 className="section-title text-center"><span>Raheja Home Care Services</span></h2>
                            <p className="text-center">At S.L. Raheja Hospital - A Fortis Associate, we bring expert medical care to your home, ensuring comfort, convenience, and recovery.</p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        {itemsToShow.length ? itemsToShow : "Loading..."}
                    </div>
                    <div className="view-all clrchng cursrpointer">
                        <a onClick={showMore}>
                            {buttonText}
                        </a>
                    </div>

                </div>
            </section>

            {/* <section className="section about-host mrgntop70 margnbot90">
                <div className="cust-container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="host-img careerjoinsec">
                                <img src={htslefttwo} alt="Worl class healthcare" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="finnest host-det mobtopmarg careerjoininner">
                                <h4> <span>Other Services</span></h4>
                                <p>Our belief in holistic care is reflected in our rehabilitation, nutrition, and critical care nutrition services. S.L. Raheja’s team of physiotherapists, occupational therapists, and rehabilitation specialists develop individualized therapy plans to restore mobility, strength, and independence. On the other hand, our dieticians work closely with doctors and other providers to develop and implement nutrition strategies that optimize your treatment outcomes. We also have dental services, ranging from preventive care and routine cleanings to more complex procedures like root canal therapy and dental implants to keep your precious smile intact. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className="section about-host mrgntop70 margnbot90">
                <div className="cust-container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="host-img careerjoinsec">
                                <img src={htslefttwo} alt="World class healthcare" />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="finnest host-det mobtopmarg careerjoininner">
                                {otherServices.length > 0 ? (
                                    otherServices.map((srv) => (
                                        <div key={srv.id}>
                                            <h4><span>{srv.heading}</span></h4>
                                            <p>{srv.content}</p>
                                        </div>
                                    ))
                                ) : (
                                    <p>Loading other services...</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}
export default HospitalTechnologService;